import Shield from "@assets/images/Shield.png";
import color from "@constants/color";
import React, { useState } from "react";
import { Image, StyleSheet, TouchableOpacity, View } from "react-native";
import Tooltip from "react-native-walkthrough-tooltip";
import CustomText from "./CustomText";
import analytics from "@services/analytics";
import { PERFORMANCE_MATRICES } from "@constants/analyticsEventsCT";

const ProgessIndicator = ({
  current = 20,
  expectation = 50,
  title = "",
  screen = "",
}) => {
  const [visible, setVisible] = useState(false);

  const textLeft = () =>
    Number.isNaN(parseFloat(current)) ? 0 : parseFloat(current) * (1 - 0.14);

  const progressWidth = () =>
    Number.isNaN(parseFloat(current)) ? 0 : parseFloat(current);

  const progressColor = current >= expectation ? color.greenHaze : color.red;

  const onShieldClick = () => {
    analytics.trackEvent(PERFORMANCE_MATRICES.SEE_EXPECTATION, {
      work: title,
      screen,
    });
  };

  return (
    <View style={{ flex: 1 }}>
      <View style={{ left: textLeft() + "%" }}>
        <CustomText
          newfont={true}
          variant="title_16"
          style={{ color: progressColor }}
        >
          {`${current}%`}
        </CustomText>
      </View>
      <View>
        <View style={styles.mainBar} />
        <View
          style={[
            styles.progressbar,
            { width: progressWidth() + "%", backgroundColor: progressColor },
          ]}
        />
        <View style={[styles.sheild, { left: expectation - 5 + "%" }]}>
          <Tooltip
            isVisible={visible}
            backgroundColor="transparent"
            contentStyle={styles.tooltipContent}
            arrowStyle={{
              elevation: 8,
              top: -15,
            }}
            displayInsets={{ top: 0, bottom: 0, left: 0, right: 0 }}
            content={
              <CustomText variant="body_text_2" style={{ color: "white" }}>
                {`${expectation}%`}
              </CustomText>
            }
            placement="bottom"
            onClose={() => setVisible(false)}
          >
            <TouchableOpacity
              testID="shield"
              onPress={() => {
                onShieldClick();
                setVisible(true);
              }}
            >
              <Image
                source={Shield}
                style={styles.shieldImg}
                resizeMode="cover"
              />
            </TouchableOpacity>
          </Tooltip>
        </View>
        <View style={[styles.dotContainer, { left: "97%" }]}>
          <View style={styles.dot} />
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  mainBar: {
    height: 8,
    backgroundColor: "rgba(220, 220, 220, 1)",
    borderRadius: 16,
  },
  progressbar: {
    height: 8,
    borderRadius: 16,
    position: "absolute",
  },
  sheild: {
    position: "absolute",
    marginTop: -7,
  },
  dotContainer: {
    position: "absolute",
  },
  dot: {
    backgroundColor: "rgba(0, 171, 89, 1)",
    height: 8,
    width: 8,
    borderColor: "rgba(255, 255, 255, 1)",
    borderWidth: 1,
    borderRadius: 4,
  },
  tooltipContent: {
    elevation: 8,
    backgroundColor: "rgba(0, 171, 89, 1)",
    top: -5,
  },
  shieldImg: {
    height: 24,
    width: 24,
  },
});

export default ProgessIndicator;
